import { render } from "./LogoChange.vue?vue&type=template&id=f05ece14&scoped=true"
import script from "./LogoChange.vue?vue&type=script&lang=js"
export * from "./LogoChange.vue?vue&type=script&lang=js"

import "./LogoChange.vue?vue&type=style&index=0&id=f05ece14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05ece14"]])

export default __exports__